/* Craftsbazaar contact — reveal, lazy map, submit state. Scoped to .cb-contact. */
(function () {
  'use strict';

  function initReveal(root) {
    root.classList.add('is-js');
    var els = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* load the heavy Google Maps iframe only when it nears the viewport */
  function initMap(root) {
    var holder = root.querySelector('.map-embed[data-src]');
    if (!holder) return;
    function load() {
      if (holder._loaded) return;
      holder._loaded = true;
      var iframe = document.createElement('iframe');
      iframe.src = holder.getAttribute('data-src');
      iframe.loading = 'lazy';
      iframe.title = holder.getAttribute('data-title') || 'Map';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      iframe.allowFullscreen = true;
      holder.appendChild(iframe);
      var ph = holder.querySelector('.map-ph');
      if (ph) { ph.style.display = 'none'; }
    }
    if (!('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { load(); io.disconnect(); } });
    }, { rootMargin: '300px 0px' });
    io.observe(holder);
  }

  /* button feedback + scroll the success panel into view */
  function initForm(root) {
    var form = root.querySelector('.cf-form');
    if (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (btn && !btn.disabled) {
          btn.disabled = true;
          btn.dataset.label = btn.textContent;
          btn.textContent = 'Sending\u2026';
        }
      });
    }
    var ok = root.querySelector('.form-success');
    if (ok) {
      try { ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { ok.scrollIntoView(); }
    }
  }

  /* infinite, draggable logo marquee */
  function initLogos(root) {
    root.querySelectorAll('.logos[data-marquee]').forEach(function (box) {
      var vp = box.querySelector('.logos-viewport');
      var track = box.querySelector('.logos-track');
      if (!vp || !track) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // keep native swipe-scroll

      box.classList.add('is-live');
      var speed = parseFloat(box.getAttribute('data-speed')) || 40; // px per second
      var half = track.scrollWidth / 2;
      function measure() { half = track.scrollWidth / 2; }
      if ('ResizeObserver' in window) { new ResizeObserver(measure).observe(track); }
      else { window.addEventListener('resize', measure); }

      var offset = 0, last = null, raf = null, paused = false;
      var dragging = false, startX = 0, startOffset = 0, moved = 0, lastX = 0, lastT = 0, vel = 0;

      function wrap() { if (half > 0) { while (offset <= -half) offset += half; while (offset > 0) offset -= half; } }
      function apply() { track.style.transform = 'translateX(' + offset + 'px)'; }
      function frame(t) {
        if (last == null) last = t;
        var dt = (t - last) / 1000; last = t;
        if (!paused && !dragging) { offset -= speed * dt; wrap(); apply(); }
        raf = requestAnimationFrame(frame);
      }
      function start() { if (!raf) { last = null; raf = requestAnimationFrame(frame); } }
      function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

      vp.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') paused = true; });
      vp.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') paused = false; });

      vp.addEventListener('pointerdown', function (e) {
        dragging = true; moved = 0; startX = e.clientX; startOffset = offset;
        lastX = e.clientX; lastT = performance.now(); vel = 0;
        vp.classList.add('is-drag');
        try { vp.setPointerCapture(e.pointerId); } catch (_) {}
      });
      vp.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX; moved = Math.abs(dx);
        offset = startOffset + dx; wrap(); apply();
        var now = performance.now(), ddt = now - lastT;
        if (ddt > 0) vel = (e.clientX - lastX) / ddt * 1000;
        lastX = e.clientX; lastT = now;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false; vp.classList.remove('is-drag');
        try { vp.releasePointerCapture(e.pointerId); } catch (_) {}
        var v = vel, steps = 0; // brief momentum glide
        (function glide() {
          if (dragging || Math.abs(v) < 8) return;
          offset += v * 0.016; v *= 0.92; wrap(); apply();
          if (steps++ < 140) requestAnimationFrame(glide);
        })();
      }
      vp.addEventListener('pointerup', endDrag);
      vp.addEventListener('pointercancel', endDrag);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      vp.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

      start();
    });
  }

  function boot() {
    document.querySelectorAll('.cb-contact').forEach(function (root) {
      initReveal(root);
      initMap(root);
      initForm(root);
      initLogos(root);
    });
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();